<template>
  <v-app>

    <v-app-bar
      v-if="this.$route.name == 'Never'"
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Dutch Bros"
          class="shrink mr-2"
          contain
          src="https://files.dutchbros.com/logos/primary_logo_blue_text.png"
          transition="scale-transition"
          width="150"
        />

      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://dutchbros.com"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>


  </v-app>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('resetState')
  }
}
</script>
